const Format = {
    OGGOPUS: 'oggopus',
    LPCM: 'lpcm',
};

const Emotion = {
    Good: 'good',
    Evil: 'evil',
    Neutral: 'neutral',
};

const Language = {
    Ru: 'ru-RU',
    En: 'en-US',
    Tr: 'tr-TR',
};

const Voice = {
    Alena: 'alena',
    Filipp: 'filipp',
    Alyss: 'alyss',
    Jane: 'jane',
    Oksana: 'oksana',
    Omazh: 'omazh',
    Zahar: 'zahar',
    Ermil: 'ermil',
};

module.exports = {
    Format,
    Emotion,
    Language,
    Voice,
};
